import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import ViewContext from '@modules/order/contexts/view-context'
import React, { FC, useContext } from 'react'
import get from 'lodash/result'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import last from 'lodash/last'
import HierarchyCell from '../../components/HierarchyCell'
import Typography from '@components/std-components/Typography'
import formatNumberByLocale from '@utils/format-number-by-locale'

const GenericDecimalValueComponent: FC<CellItem> = ({ rowData, column }) => {
  const {
    uiStore: { getHierarchy }
  } = useContext(ViewContext)
  if (!rowData) {
    return (
      <HierarchyCell>
        <FieldSkeleton />
      </HierarchyCell>
    )
  }
  const hierarchy = rowData?.name && getHierarchy(rowData?.name)
  const val = Number(get(last(hierarchy), column?.field) ?? 0)
  return (
    <HierarchyCell>
      <Typography variant='subHeading1'>{formatNumberByLocale(val)}</Typography>
    </HierarchyCell>
  )
}

export default GenericDecimalValueComponent
